var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-body"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.authorised === true)?_c('div',[_c('router-view')],1):_c('div',[_c('Unauthorised')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }